import React from 'react';
import { LoadingBase } from './LoadingBase';

const LoadingModal = ({ className = '', ...props }) => (
  <LoadingBase className={`loading--modal ${className}`} {...props} />
);

export { LoadingModal };



// WEBPACK FOOTER //
// ./src/components/loading/LoadingModal.js